'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import React, { useEffect } from 'react'
import { initPostHog } from './init-posthog'

export const PostHogProvider = ({
  children
}: {
  children: React.ReactNode
}): React.ReactElement => {
  useEffect(() => {
    initPostHog()
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
